import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "sprout-ui-primitives";
import Avatar from "../Avatar";
const PostAvatar = (props)=>{
    const { owner  } = props;
    return /*#__PURE__*/ _jsx(Box, {
        flex: "none",
        mr: "8px",
        children: /*#__PURE__*/ _jsx(Avatar, {
            user: owner,
            navigable: true
        })
    });
};
export default PostAvatar;
